<template>
  <SkeletonLoader>
    <div class="admin-skeleton">
      <!-- Header: greeting -->
      <div class="admin-skeleton__header">
        <div class="sk-line sk-line--xl" style="width: 40%"></div>
      </div>

      <!-- Stats bar: horizontal scroll of 5 pills -->
      <div class="admin-skeleton__stats">
        <div
          v-for="pill in statPills"
          :key="pill.id"
          class="admin-skeleton__pill sk-rect"
          :style="{ width: pill.width, height: '56px' }"
        ></div>
      </div>

      <!-- Dashboard grid: 2x2 -->
      <div class="admin-skeleton__grid">
        <!-- Widget 1: title + 4 table rows -->
        <div class="admin-skeleton__widget">
          <div class="sk-line sk-line--title" :style="{ width: widgetTitles[0] }"></div>
          <div v-for="row in tableRowsA" :key="'w1-' + row.id" class="sk-row">
            <div class="sk-circle sk-circle--sm"></div>
            <div class="sk-col">
              <div class="sk-line" :style="{ width: row.width }"></div>
            </div>
            <div class="sk-line sk-line--sm" :style="{ width: row.trailing }"></div>
          </div>
        </div>

        <!-- Widget 2: title + chart placeholder -->
        <div class="admin-skeleton__widget">
          <div class="sk-line sk-line--title" :style="{ width: widgetTitles[1] }"></div>
          <div class="sk-rect" style="width: 100%; height: 150px"></div>
        </div>

        <!-- Widget 3: title + 4 table rows -->
        <div class="admin-skeleton__widget">
          <div class="sk-line sk-line--title" :style="{ width: widgetTitles[2] }"></div>
          <div v-for="row in tableRowsB" :key="'w3-' + row.id" class="sk-row">
            <div class="sk-circle sk-circle--sm"></div>
            <div class="sk-col">
              <div class="sk-line" :style="{ width: row.width }"></div>
            </div>
            <div class="sk-line sk-line--sm" :style="{ width: row.trailing }"></div>
          </div>
        </div>

        <!-- Widget 4: title + 4 table rows -->
        <div class="admin-skeleton__widget">
          <div class="sk-line sk-line--title" :style="{ width: widgetTitles[3] }"></div>
          <div v-for="row in tableRowsC" :key="'w4-' + row.id" class="sk-row">
            <div class="sk-circle sk-circle--sm"></div>
            <div class="sk-col">
              <div class="sk-line" :style="{ width: row.width }"></div>
            </div>
            <div class="sk-line sk-line--sm" :style="{ width: row.trailing }"></div>
          </div>
        </div>
      </div>
    </div>
  </SkeletonLoader>
</template>

<script>
import SkeletonLoader from '@/components/SkeletonLoader.vue'

export default {
  name: 'AdminPage2Skeleton',
  components: { SkeletonLoader },
  data () {
    return {
      statPills: [
        { id: 1, width: '140px' },
        { id: 2, width: '160px' },
        { id: 3, width: '130px' },
        { id: 4, width: '150px' },
        { id: 5, width: '145px' }
      ],
      widgetTitles: ['45%', '50%', '55%', '40%'],
      tableRowsA: [
        { id: 1, width: '75%', trailing: '48px' },
        { id: 2, width: '60%', trailing: '36px' },
        { id: 3, width: '85%', trailing: '52px' },
        { id: 4, width: '50%', trailing: '40px' }
      ],
      tableRowsB: [
        { id: 1, width: '70%', trailing: '44px' },
        { id: 2, width: '55%', trailing: '38px' },
        { id: 3, width: '80%', trailing: '50px' },
        { id: 4, width: '65%', trailing: '42px' }
      ],
      tableRowsC: [
        { id: 1, width: '68%', trailing: '46px' },
        { id: 2, width: '82%', trailing: '34px' },
        { id: 3, width: '58%', trailing: '48px' },
        { id: 4, width: '72%', trailing: '40px' }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.admin-skeleton {
  padding: 24px;

  &__header {
    margin-bottom: 24px;
  }

  &__stats {
    display: flex;
    gap: 12px;
    overflow-x: auto;
    padding-bottom: 8px;
    margin-bottom: 24px;
    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar {
      height: 4px;
    }
    &::-webkit-scrollbar-thumb {
      background: #cbd5e1;
      border-radius: 2px;
    }
  }

  &__pill {
    flex-shrink: 0;
    border-radius: 8px;
  }

  &__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }

  &__widget {
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 20px;
  }
}
</style>
